export default __webpack_public_path__ + "static/streamlining-claims-processing-with-robotic-process-automation-RPA-cb7522dea2eac363baa65e24cf38afe8.png";